module.exports = __webpack_public_path__ + "flyer_background_cake_and_plates_102-57f248b33c2aae1dcd6b1ea1ce97c31f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_cake_and_plates_102.jpg
// module id = 1614
// module chunks = 1